import { IIcon } from '@/types/generalTypes';

const HandShakeIcon = ({ className }: IIcon) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.3335 11.3333L8.66683 12.6666C8.79815 12.7979 8.95405 12.9021 9.12563 12.9732C9.29721 13.0443 9.48111 13.0808 9.66683 13.0808C9.85255 13.0808 10.0364 13.0443 10.208 12.9732C10.3796 12.9021 10.5355 12.7979 10.6668 12.6666C10.7982 12.5353 10.9023 12.3794 10.9734 12.2078C11.0445 12.0362 11.081 11.8523 11.081 11.6666C11.081 11.4809 11.0445 11.297 10.9734 11.1254C10.9023 10.9538 10.7982 10.7979 10.6668 10.6666M9.33365 9.3333L11.0003 11C11.2655 11.2652 11.6252 11.4142 12.0003 11.4142C12.3754 11.4142 12.7351 11.2652 13.0003 11C13.2655 10.7348 13.4145 10.375 13.4145 9.99997C13.4145 9.6249 13.2655 9.26519 13.0003 8.99997L10.4136 6.4133C10.0386 6.03877 9.53032 5.8284 9.00031 5.8284C8.47031 5.8284 7.96198 6.03877 7.58698 6.4133L7.00031 6.99997C6.7351 7.26519 6.37539 7.41418 6.00031 7.41418C5.62524 7.41418 5.26553 7.26519 5.00031 6.99997C4.7351 6.73475 4.5861 6.37504 4.5861 5.99997C4.5861 5.6249 4.7351 5.26519 5.00031 4.99997L6.87365 3.12664C7.48181 2.52007 8.27491 2.13367 9.12741 2.02862C9.9799 1.92357 10.8431 2.10586 11.5803 2.54664L11.8936 2.7333C12.1775 2.90463 12.515 2.96405 12.8403 2.89997L14.0003 2.66664M14.0002 1.99996L14.6668 9.33329H13.3335M2.00016 1.99996L1.3335 9.33329L5.66683 13.6666C5.93205 13.9318 6.29176 14.0808 6.66683 14.0808C7.0419 14.0808 7.40161 13.9318 7.66683 13.6666C7.93205 13.4014 8.08104 13.0417 8.08104 12.6666C8.08104 12.2916 7.93205 11.9318 7.66683 11.6666M2.00016 2.66663H7.3335'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default HandShakeIcon;
